module.exports = __webpack_public_path__ + "img/蟾酥.9c6e163d.jpg";